import { Component } from '@angular/core';
import { PrimeNGButtonDeleteItemActionComponent } from '@ntap/primeng';

@Component({
  selector: 'app-obrisi-klasa-action',
  templateUrl: '../../../shared/components/actions/common-action-template.html'
})
export class ObrisiKlasaItemActionComponent extends PrimeNGButtonDeleteItemActionComponent {
  override getConfirmationMessage(): string {
    return 'Jeste li sigurni da želite obrisati klasu s podklasama?';
  }
}
